import styled from 'styled-components';
import Input from '@components/Input';

export const Container = styled.div`
  width: 300px;
  height: 300px;
`;

export const Title = styled.h2`
  font-size: 18px;
  color: #333;
  text-align: center;
  margin: 20px 0;
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;

  & > label {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-left: 5px;
    margin-right: 5px;
  }
`;

export const DateInput = styled(Input).attrs(() => ({
  type: 'date',
  max: '9999-12-31',
  minWidth: '350px',
  display: 'flex',
}))``;

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  margin-top: 20px;

  button {
    margin-left: 15px;
  }
`;
